import type { ReactNode } from 'react';
import { AtlasSpriteThumb } from '@/components/village-map/AtlasSpriteThumb';

export function VillageArtLabel({
  sprite,
  children,
  size = 22,
}: {
  sprite?: string;
  children: ReactNode;
  size?: number;
}) {
  return (
    <span className="flex min-w-0 max-w-full items-center gap-1.5">
      {sprite ? (
        <AtlasSpriteThumb
          sprite={sprite}
          label={typeof children === 'string' ? children : sprite}
          size={size}
          plain
        />
      ) : null}
      <span className="truncate">{children}</span>
    </span>
  );
}

export function VillageArtMark({ sprite, size = 28 }: { sprite: string; size?: number }) {
  return <AtlasSpriteThumb sprite={sprite} size={size} plain />;
}
